"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _superSegments = require("../../reducers/superSegments");

var _actions = require("../../actions");

var _index = require("../../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GenerateAdsFacebookMockup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GenerateAdsFacebookMockup, _React$Component);

  function GenerateAdsFacebookMockup(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // Set Default State

    _defineProperty(_assertThisInitialized(_this), "handleSetHeadline", function (newHeadingId) {
      _this.setState({
        currentHeadline: newHeadingId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSetDescription", function (newDescriptionId) {
      _this.setState({
        currentDescription: newDescriptionId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSetAdCopy", function (newAdCopyId) {
      _this.setState({
        currentAdCopy: newAdCopyId
      });
    });

    _this.state = {
      headlines: [],
      descriptions: [],
      adCopy: [],
      currentHeadline: 0,
      currentDescription: 0,
      currentAdCopy: 0,
      company: props.data.company,
      url: props.data.url
    };

    if (props.results) {
      if (props.results.headlines && props.results.headlines.length > 0) {
        _this.state.headlines = props.results.headlines;
      }

      if (props.results.descriptions && props.results.descriptions.length > 0) {
        _this.state.descriptions = props.results.descriptions;
      }

      if (props.results.adCopy && props.results.adCopy.length > 0) {
        _this.state.adCopy = props.results.adCopy;
      }
    }

    return _this;
  }

  var _proto = GenerateAdsFacebookMockup.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        currentHeadline = _this$state.currentHeadline,
        currentDescription = _this$state.currentDescription,
        currentAdCopy = _this$state.currentAdCopy,
        headlines = _this$state.headlines,
        descriptions = _this$state.descriptions,
        adCopy = _this$state.adCopy,
        company = _this$state.company,
        url = _this$state.url;
    var isLoaded = headlines && descriptions && headlines.length > 0 && descriptions.length > 0 && adCopy && adCopy.length > 0; // Define content variables

    var headerContent = {
      faviconUrl: 'favicon.png',
      // Replace with the actual URL of the favicon
      groupName: company
    };
    var contentContent = {
      description: adCopy[currentAdCopy],
      imageUrl: 'full_width_image.jpg' // Replace with the actual URL of the image

    };
    var footerContent = {
      siteUrl: url,
      heading: headlines[currentHeadline],
      shortDescription: descriptions[currentDescription]
    };
    var mockupWrapper = {
      width: '100%'
    };
    var headerMockup = {
      alignSelf: 'stretch',
      color: '#27251F',
      fontFamily: 'Proxima Nova',
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '25.6px' // You can use a string for this value

    };
    var subtitleStyle = {
      display: 'flex',
      width: '236px',
      height: '26px',
      flexDirection: 'column',
      justifyContent: 'center',
      color: '#27251F',
      fontFamily: 'Proxima Nova',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '25.6px',
      marginBottom: '10px'
    };
    var selectMenuList = {
      display: 'block',
      marginBottom: '10px'
    };
    var selectionMenuItem = {
      padding: '4px 8px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      borderRadius: '4px',
      background: 'none'
    };
    var activeMenuItem = {
      padding: '4px 8px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      borderRadius: '4px',
      background: '#00ACCA',
      color: '#fff'
    }; // Define CSS variables

    var styles = {
      wrapper: {
        display: 'flex',
        paddingTop: '10px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        border: '1px solid #FFF',
        background: '#FFF'
      },
      header: {
        wrapper: {
          display: 'flex',
          alignItems: 'center',
          gap: '245px'
        },
        inner: {
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        },
        right: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start'
        },
        favicon: {
          width: '28px',
          height: '28px',
          background: '#EDEEF0',
          borderRadius: '14px'
        },
        title: {
          display: 'flex',
          width: '161px',
          height: '18px',
          flexDirection: 'column',
          justifyContent: 'center',
          color: '#050505',
          fontFamily: 'Arial',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: '600',
          lineHeight: '25.6px' // You can use a string for this value

        },
        sponsor: {
          display: 'flex',
          width: '161px',
          height: '18px',
          flexDirection: 'column',
          justifyContent: 'center',
          color: '#75777B',
          fontFamily: 'Arial',
          fontSize: '9px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '25.6px'
        }
      },
      contentStyle: {
        backgroundColor: '#fff',
        padding: '0 10px'
      },
      contentAdCopy: {
        color: '#75777B',
        fontFamily: 'Arial',
        fontSize: '11px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '130%',
        // You can use a string for this value
        letterSpacing: '-0.165px',
        textAlign: 'left'
      },
      contentImage: {
        height: '446px',
        border: 'solid 1px lightgrey',
        background: 'url(https://cms.arcadiandigital.com.au/wp-content/uploads/2023/09/adgenerator_facebook1.png)',
        backgroundSize: 'cover'
      },
      contentImageText: {
        width: '161px',
        position: 'relative',
        left: '151px',
        top: '200px',
        color: '#FFF',
        textAlign: 'center',
        fontFamily: 'Arial',
        fontSize: '20px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '25.6px' // You can use a string for this value

      },
      footerStyle: {
        width: '100%',
        backgroundColor: '#fff',
        padding: '0 10px'
      },
      footerContent: {
        padding: '0',
        display: 'inline-block'
      },
      footerButton: {
        display: 'inline-block',
        "float": 'right',
        textAlign: 'right',
        padding: '10px'
      },
      footer: {
        wrapper: {
          display: 'flex',
          width: '485px',
          padding: '8px 12px',
          alignItems: 'center',
          gag: '24px'
        },
        left: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '8px'
        },
        url: {
          display: 'flex',
          width: '161px',
          height: '9px',
          flexDirection: 'column',
          justifyContent: 'center',
          color: '#75777B',
          leadingTrim: 'both',
          textEdge: 'cap',
          fontFamily: 'Arial',
          fontSize: '9px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '25.6px',
          // You can use a string for this value
          textTransform: 'uppercase'
        },
        headline: {
          display: 'flex',
          width: '366px',
          height: '12px',
          flexDirection: 'column',
          justifyContent: 'center',
          overflow: 'hidden',
          color: '#050505',
          leadingTrim: 'both',
          textEdge: 'cap',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontFamily: 'Arial',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: '600',
          lineHeight: '25.6px'
        },
        // You can use a string for this value},
        description: {
          display: 'flex',
          width: '366px',
          height: '12px',
          flexDirection: 'column',
          justifyContent: 'center',
          overflow: 'hidden',
          color: '#75777B',
          leadingTrim: 'both',
          textEdge: 'cap',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontFamily: 'Arial',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '25.6px',
          // You can use a string for this value
          letterSpacing: '-0.165px'
        },
        button: {
          display: 'flex',
          padding: '0px 5px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          borderRadius: '4px',
          background: '#E4E6EB',
          height: '26px'
        }
      },
      ui: {
        wrapper: {
          display: 'flex',
          padding: '0px 16px',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          backgroundColor: '#fff',
          width: '485px',
          height: '29px'
        },
        left: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          overflow: 'hidden',
          color: '#75777B',
          textOverflow: 'ellipsis',
          whitespace: 'nowrap',
          fontFamily: 'Arial',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '25.6px',
          letterSpacing: '-0.165px'
        },
        right: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          overflow: 'hidden',
          color: '#75777B',
          textOverflow: 'ellipsis',
          whitespace: 'nowrap',
          fontFamily: 'Arial',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '25.6px',
          letterSpacing: '-0.165px'
        }
      },
      likesCount: 123 // Replace with the actual number of likes

    };
    var buttonNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    var adCopyNumbers = [1, 2, 3, 4, 5, 6];
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isLoaded ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "google-ad-mockup__wrapper",
      style: mockupWrapper
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      style: headerMockup
    }, "Facebook MockUp"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mockup-section__headline",
      style: selectMenuList
    }, /*#__PURE__*/_react["default"].createElement("p", {
      style: subtitleStyle
    }, "Select Headline"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "headline__button-list"
    }, buttonNumbers.map(function (buttonNumber, key) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: key,
        onClick: function onClick() {
          return _this2.handleSetHeadline(key);
        },
        style: currentHeadline === key ? activeMenuItem : selectionMenuItem,
        className: "headline__list-item"
      }, buttonNumber);
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mockup-section__headline",
      style: selectMenuList
    }, /*#__PURE__*/_react["default"].createElement("p", {
      style: subtitleStyle
    }, "Select Description"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mockup-section__description",
      style: selectMenuList
    }, buttonNumbers.map(function (buttonNumber, key) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: key,
        onClick: function onClick() {
          return _this2.handleSetDescription(key);
        },
        style: currentDescription === key ? activeMenuItem : selectionMenuItem,
        className: "description__list-item"
      }, buttonNumber);
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mockup-section__adcopy",
      style: selectMenuList
    }, /*#__PURE__*/_react["default"].createElement("p", {
      style: subtitleStyle
    }, "Select Ad Copy"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mockup-section__adcopy",
      style: selectMenuList
    }, adCopyNumbers.map(function (buttonNumber, key) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: key,
        onClick: function onClick() {
          return _this2.handleSetAdCopy(key);
        },
        style: currentAdCopy === key ? activeMenuItem : selectionMenuItem,
        className: "adcopy__list-item"
      }, buttonNumber);
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-ad-post",
      style: styles.wrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-ad-header",
      style: styles.header.wrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.header.inner
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-ad-favicon",
      style: styles.header.favicon
    }), /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.header.right
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.header.title
    }, headerContent.groupName), /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.header.sponsor
    }, "Sponsored"))), /*#__PURE__*/_react["default"].createElement("div", null, "...")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-ad-content",
      style: styles.contentStyle
    }, /*#__PURE__*/_react["default"].createElement("p", {
      style: styles.contentAdCopy,
      className: "facebook-ad-adcopy"
    }, contentContent.description), /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.contentImage,
      className: "facebook-ad-image"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.contentImageText
    }, "Image Goes Here"))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-ad-footer",
      style: styles.footer.wrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.footer.left
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.footer.url
    }, footerContent.siteUrl), /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.footer.headline
    }, footerContent.heading), /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.footer.description
    }, footerContent.shortDescription)), /*#__PURE__*/_react["default"].createElement("button", {
      style: styles.footer.button,
      className: "inverted"
    }, "View More")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-ad-ui",
      style: styles.ui.wrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.ui.left,
      className: "facebook-ad-likes"
    }, "3K Likes"), /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.ui.right,
      className: "facebook-ad-like-button"
    }, "184 Comments 77 Shares")))) : '');
  };

  return GenerateAdsFacebookMockup;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(state) {
  var workflowPermission = state.options.permissions.workflowPermission;
  return {
    formLoading: state.superSegments.formLoading,
    communityImages: (0, _superSegments.getCommunityImages)(state),
    campaignCreatorAccess: state.featureAccess.byId && state.featureAccess.byId[workflowPermission] && state.featureAccess.byId[workflowPermission].hasAccess,
    firstLandingPage: state.campaignCreator.options.firstLandingPage
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadSuperSegments: _actions.loadSuperSegments,
    featureAccess: _index.featureAccess
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GenerateAdsFacebookMockup);

exports["default"] = _default;